
<template>
    <section class="client-work-item" :aria-label="itemData.title">

        <!-- Item preview image - START -->
        <div class="client-work-item__image">
            <!-- Preview image with link -->
            <a :href="itemData.url" target="_blank">
                <responsive-image-reveal
                    :responsiveImage="responsiveImage"
                    :imageSizes="imageSizes"
                    :imageAltText="'Screenshot of ' + itemData.title + ' website'">
                </responsive-image-reveal>
            </a>
        </div>
        <!-- Item preview image - END -->

        <!-- Item copy - START -->
        <div class="client-work-item__copy-container">
            <div class="client-work-item__copy-top">
                <!-- Title -->
                <h3 class="client-work-item__title">
                    <a v-if="itemData.live"
                        :href="itemData.url"
                        target="_blank">
                        {{ itemData.title }}
                    </a>
                    <span v-else>
                        {{ itemData.title }}
                    </span>
                </h3>

                <!-- Client description -->
                <p class="client-work-item__client-description">{{ itemData.clientDescription }}</p>

                <!-- Technology -->
                <p class="client-work-item__technology">{{ itemData.technology }}</p>
            </div>

            <div class="client-work-item__copy-bottom">
                <!-- Is site live? -->
                <p v-if="itemData.live == false">
                    Project is no longer online.
                </p>

                <!-- Link -->
                <p>
                    <a :href="itemData.url" class="client-work-item__view-link" target="_blank">
                        <icon name="angle-right"></icon>
                        <span v-if="itemData.live">View site</span>
                        <span v-else>View on Internet Archive</span>
                    </a>
                </p>
            </div>
        </div>
        <!-- Item copy - END -->

    </section>
</template>

<script>
import breakpoints from '@/mixins/Breakpoints';
import icon from '@/components/Icon.vue';
import responsiveImageReveal from '@/components/ResponsiveImageReveal.vue';

export default {
    mixins: [breakpoints],
    props: {
        itemData: Object,
    },
    components: {
        icon,
        responsiveImageReveal,
    },
    computed: {
        // imageSizes - Generate a list of maximum image widths at each
        // breakpoint, this will be used in the 'sizes' attribute of the
        // 'srcset' for the image.
        imageSizes() {
            let imageSizes = '';

            imageSizes += `(min-width: ${this.breakpoints.xl}px) 438px, `; // xl - *
            imageSizes += `(min-width: ${this.breakpoints.lg}px) 411px, `; // lg - xl
            imageSizes += `(min-width: ${this.breakpoints.ml}px) 522.5px, `; // ml - lg
            imageSizes += `(min-width: ${this.breakpoints.md}px) 454.5px, `; // md - ml
            imageSizes += `(min-width: ${this.breakpoints.sm}px) 351.5px, `; // sm - md
            imageSizes += `(min-width: ${this.breakpoints.xs}px) 493px, `; // xs - sm
            imageSizes += `(min-width: ${this.breakpoints.ti}px) 405px, `; // ti - xs
            imageSizes += '278px'; // 0 - ti

            return imageSizes;
        },

        // responsiveImage - Generate a responsive image object with the
        // specified widths including 2x retina.
        // Widths: 278, 352, 455, 523
        // Retina: 556, 704, 910, 1046
        responsiveImage() {
            // eslint-disable-next-line max-len
            return require(`@/assets/img/client-work/${this.itemData.machineName}/${this.itemData.machineName}.png?sizes[]=278,sizes[]=352,sizes[]=455,sizes[]=523,sizes[]=556,sizes[]=704,sizes[]=910,sizes[]=1046`);
        },
    },
};
</script>

<style lang="scss">
.client-work-item {
    flex-grow: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: $color-smoke;
    border: solid 1px $color-smoke;
}

.client-work-item__image {
    @include mq($from: xs, $until: sm) {
        padding: 2rem 2rem 0 2rem;
    }

    a {
        display: block;
    }
}

.client-work-item__copy-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1.7rem 2rem 1.5rem 2rem;

    @include mq($from: md) {
        padding: 2.5rem 3rem;
    }
}

.client-work-item__copy-top {
    margin-bottom: 1.7rem;

    @include mq($from: md) {
        margin-bottom: 2.1rem;
    }
}

.client-work-item__title {
    margin-bottom: 0.5rem;

    a {
        font-size: 1.8rem;
        text-decoration: none;

        &:hover {
            color: $color-primary;
        }

        @include mq($from: md) {
            font-size: 2.2rem;
        }
    }
}

.client-work-item__client-description {
    margin-bottom: 1.5rem;
    color: $color-hitachi;

    @include mq($from: md) {
        margin-bottom: 2.3rem;
    }
}

.client-work-item__view-link {
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1;
    text-transform: uppercase;
    text-decoration: none;

    .icon {
        width: 1.4rem;
        height: 1.4rem;
        margin-left: -0.4rem;
    }
}
</style>
